/** PM State — global state variables and constants. */

/**
 * Format a Date object as HH:MM:SS
 * @param {Date} date - The date to format
 * @returns {string} Formatted time string
 */
window.formatTimeNow = function(date) {
  return ((date.getHours() < 10) ? "0" : "") + date.getHours() + ":" +
    ((date.getMinutes() < 10) ? "0" : "") + date.getMinutes() + ":" +
    ((date.getSeconds() < 10) ? "0" : "") + date.getSeconds();
};

// The signed-in user's id as a string (ids exceed Number.MAX_SAFE_INTEGER).
window.pmCurrentUserId = function() {
  var meta = document.querySelector('meta[name="user-id"]');
  return meta ? String(meta.getAttribute('content') || '') : '';
};

window.pm_ajax_request_active = 0;
// jQuery timeout for PM reads. A read that never settles holds pm_ajax_request_active or _pollInFlight and stops polls.
// Writes keep no timeout: a client timeout cannot tell whether the server applied the write.
window.PM_REQUEST_TIMEOUT_MS = 30000;
window.messages_highlighted = 1;
window.last_ads_reload = new Date().getTime();
// Avoid multiple calls of load more threads called by scroll
window.load_more_threads_active = 0;
// Avoid multiple calls of load_more_msg
window.load_more_msg_active = 0;
// Array of drafts
window.last_draft = {};
// Track if user is currently swiping/dragging on mobile
window.isDragging = false;
// Geometry threads_main_resize() last pinned onto .privateMessages. Null until
// the first layout pass, which the load diagnostics report as unknown rather
// than as a measurement.
window.pmLastLayout = {
  availableHeight: null,
  containerTop: null,
  hasNoThreads: null,
  threadOpen: null
};
// Paginated view state
window.pagedViewActive = false;
window.pagedViewRequestSeq = 0;
window.pagedViewLoadPending = false;

window.err_div = $("<div style=\"color:red\"></div>");
window.err_txt = "Error during processing, please reload page and try again.";

window.isMarkitUpLoaded = function() {
  return typeof $.markItUp === "function";
};
